// Leaderboard.js
import React from "react";
import Grid from "@mui/material/Grid2";
import { Typography, Box, Avatar } from "@mui/material";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

const Leaderboard = ({ data = [], type }) => {
  const boardType = {
    points: "PPG",
    rebounds: "RPG",
    assists: "APG",
    overall: "OVR",
    defense: "DEF",
    playmaking: "Playmaking",
    ball_handling: "Handle",
  };

  const navigate = useNavigate();

  const getValue = (item) => {
    switch (type) {
      case "points":
        return parseFloat(item.points);
      case "rebounds":
        return parseFloat(item.rebounds);
      case "assists":
        return parseFloat(item.assists);
      case "overall":
        return parseInt(item.overall);
      case "defense":
        return parseInt(item.defense);
      case "playmaking":
        return parseInt(item.playmaking);
      case "ball_handling":
        return parseInt(item.ball_handling);
      default:
        return 0;
    }
  };

  const handlePlayerClick = (playerId) => {
    navigate(`/player/${playerId}`);
  };

  return (
    <Box
      sx={{
        backgroundColor: "#1a1a1a",
        color: "#fff",
        padding: 2,
        borderRadius: 2,
        marginTop: 3,
      }}
    >
      {data.map((user, index) => {
        const rankClass = `top-${index + 1}`;
        return (
          <Box
            key={user.id}
            className={`leaderboard-box ${index < 3 ? rankClass : ""}`}
            onClick={() => handlePlayerClick(user.id)}
            sx={{
              display: "flex",
              alignItems: "center",
              padding: "8px 16px",
              borderRadius: 1,
              backgroundColor:
                index === 0
                  ? "#00264d"
                  : index === 1
                  ? "#003366"
                  : index === 2
                  ? "#660000"
                  : "#262626",
              cursor: "pointer",
              "&:hover": {
                opacity: 0.9,
              },
            }}
          >
            <Typography
              className={`rank ${index < 3 ? rankClass : ""}`}
              sx={{
                marginRight: "10px",
                fontSize: "1.2em",
                color: "#fff",
              }}
            >
              #{index + 1}
            </Typography>
            <div className="avatar-container">
              <Avatar
                src={user.avatar}
                alt={user.name}
                className={`avatar ${index < 3 ? rankClass : ""}`}
                sx={{
                  width: index < 3 ? "60px" : "40px",
                  height: index < 3 ? "60px" : "40px",
                  margin: "auto",
                }}
              />
            </div>
            <Box sx={{ flexGrow: 1 }}>
              <Typography
                style={{ lineHeight: "1.2", marginRight: "10px" }}
                variant="h6"
              >
                {user.name}
              </Typography>
            </Box>
            <Box sx={{ textAlign: "right" }}>
              <Typography variant="body1">
                {type === "assists"
                  ? (getValue(user) / 3).toFixed(1)
                  : [
                      "overall",
                      "defense",
                      "playmaking",
                      "ball_handling",
                    ].includes(type)
                  ? getValue(user)
                  : getValue(user).toFixed(1)}
                <span
                  style={{ fontSize: "0.6em", opacity: 0.7, marginLeft: "4px" }}
                >
                  {boardType[type]}
                </span>
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

Leaderboard.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      points: PropTypes.string,
      rebounds: PropTypes.string,
      assists: PropTypes.number,
      overall: PropTypes.string,
      defense: PropTypes.string,
      playmaking: PropTypes.string,
      ball_handling: PropTypes.string,
      avatar: PropTypes.string.isRequired,
    })
  ),
  type: PropTypes.oneOf([
    "points",
    "rebounds",
    "assists",
    "overall",
    "defense",
    "playmaking",
    "ball_handling",
  ]).isRequired,
};

export default Leaderboard;
